export const TIMELINE_ENTRY_ID_PARAM = 'timelineEntryId';
